import { Badge } from '../ui/badge';
import { Label } from '../ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { Truck, Receipt, FileText } from 'lucide-react';

/** Selettore tipo documento (bloccato in modifica). */
export const TipoDocumentoSelect = ({ tipo, editing, tipiVisibili, onChange }) => (
  <div>
    <Label className="text-xs font-mono uppercase">Tipo Documento *</Label>
    {editing ? (
      <div className="flex items-center gap-2 h-10 px-3 bg-muted/50 border rounded-md">
        {tipo === 'ddt' && <Truck className="h-4 w-4 text-amber-500" />}
        {tipo === 'fattura' && <Receipt className="h-4 w-4 text-emerald-500" />}
        {tipo === 'nota_credito' && <Receipt className="h-4 w-4 text-red-500" />}
        {(tipo === 'preventivo' || tipo === 'offerta') && <FileText className="h-4 w-4 text-blue-500" />}
        <span className="font-medium uppercase">{tipo?.replace('_', ' ')}</span>
        <Badge variant="outline" className="ml-auto text-[10px]">Non modificabile</Badge>
      </div>
    ) : (
      <Select value={tipo} onValueChange={onChange}>
        <SelectTrigger className="rounded-md" data-testid="documento-tipo">
          <SelectValue />
        </SelectTrigger>
        <SelectContent className="rounded-md">
          <SelectItem value="preventivo">
            <span className="flex items-center gap-2"><FileText className="h-4 w-4 text-blue-500" /> Preventivo</span>
          </SelectItem>
          <SelectItem value="offerta">
            <span className="flex items-center gap-2"><FileText className="h-4 w-4 text-purple-500" /> Offerta</span>
          </SelectItem>
          {tipiVisibili.includes('ddt') && (
            <SelectItem value="ddt">
              <span className="flex items-center gap-2"><Truck className="h-4 w-4 text-amber-500" /> DDT (Documento di Trasporto)</span>
            </SelectItem>
          )}
          {tipiVisibili.includes('fattura') && (
            <SelectItem value="fattura">
              <span className="flex items-center gap-2"><Receipt className="h-4 w-4 text-emerald-500" /> Fattura</span>
            </SelectItem>
          )}
          {tipiVisibili.includes('nota_credito') && (
            <SelectItem value="nota_credito">
              <span className="flex items-center gap-2"><Receipt className="h-4 w-4 text-red-500" /> Nota di Credito</span>
            </SelectItem>
          )}
        </SelectContent>
      </Select>
    )}
  </div>
);
